import { render, staticRenderFns } from "./AppBrandSection.vue?vue&type=template&id=6f9e663e&"
import script from "./AppBrandSection.vue?vue&type=script&lang=js&"
export * from "./AppBrandSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports